export default "__VITE_ASSET__da2950d0__"